import React, { FC, useEffect, useState } from 'react';
import { getAllAnetaPacks } from 'actions/aneta-pack';
import { connect, useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import { IRootState } from 'store';
import Modal from 'components/common/modal/modal';
import AnetaPackLibrary from 'components/common/AnetaPackLibrary/index';
import AnetapackMerge from 'components/common/anetapackModals/anetapackMerge';
import AnetapackOptions from 'components/common/anetapackModals/applyAnetapackOptions';
import AnetapackContent from 'components/common/anetapackModals/anetapackContent';
import buttons from 'style/buttons.module.scss';
import Title from 'components/common/Title';
import { IAnetaPacks, PopupData } from 'types';
import { isTeacherSelector } from 'selectors/user';
import ScholarsList from './scholarsList';
import style from './index.module.scss';

const mstp = (state: IRootState) => state.anetaPack;

type Props = ReturnType<typeof mstp> & {
  popupData: PopupData;
  isActiveSubscription: boolean;
};

const Scholars: FC<Props> = ({
  anetaPacks,
  popupData,
  isActiveSubscription,
}) => {
  const isTeacher = useSelector(isTeacherSelector);
  const [selectedAnetaPack, setSelectedAnetaPack] = useState<number>();
  const [isOpenContent, setIsOpenContent] = useState(false);
  const [isOpenOptions, setIsOpenOptions] = useState(false);
  const [isOpenMerge, setIsOpenMerge] = useState(false);
  const [isOpenLibrary, setIsOpenLibrary] = useState(false);
  const [selectedDate, setSelectedDate] = useState(moment().toDate());
  const searcIndex = (inputArray: moment.Moment[][], searchValue: string) => {
    const arrayString: string[][] =
      (!_.isEmpty(inputArray) &&
        inputArray.map((w: moment.Moment[]) => {
          const toString = w.map((day: moment.Moment) => {
            return moment(day).format('YYYY-MM-DD');
          });
          return toString;
        })) ||
      [];

    for (let i = 0, l = inputArray.length; i < l; i += 1) {
      const j = arrayString[i].indexOf(searchValue);
      if (j >= 0) {
        return [i, j];
      }
    }
    return null;
  };
  const handleOpenMerge = (date?: Date) => {
    setIsOpenMerge(!isOpenMerge);
    if (date) {
      setSelectedDate(date);
    }
  };
  const handleOpenContent = () => {
    setIsOpenContent(!isOpenContent);
  };
  const handleOpenOptions = () => {
    setIsOpenOptions(!isOpenOptions);
  };
  const handleOpenLibrary = () => {
    setIsOpenLibrary(!isOpenLibrary);
  };
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllAnetaPacks());
  }, [dispatch]);

  const handleChooseAnetapack = (value: IAnetaPacks) => {
    setSelectedAnetaPack(value.id);
  };

  return (
    <div className={style.wrapper}>
      <Modal
        isOpen={isOpenOptions}
        modalOpen={handleOpenOptions}
        modalContent={
          <AnetapackOptions
            openNext={handleOpenMerge}
            handleClose={handleOpenOptions}
            selectedAnetaPackId={selectedAnetaPack || 0}
          />
        }
      />
      <Modal
        isOpen={isOpenMerge}
        modalOpen={handleOpenMerge}
        withoutBackground
        modalContent={
          <AnetapackMerge
            handleClose={handleOpenMerge}
            searcIndex={searcIndex}
            openPrev={handleOpenOptions}
            selectedAnetaPackId={selectedAnetaPack || 0}
            date={selectedDate}
          />
        }
      />
      <Modal
        isOpen={isOpenContent}
        modalOpen={handleOpenContent}
        withoutBackground
        modalContent={
          <AnetapackContent
            handleClose={handleOpenContent}
            openNext={handleOpenOptions}
            selectedAnetaPackId={selectedAnetaPack || 0}
          />
        }
      />
      <Title>Welcome Back</Title>
      <div className={style.buttonsBlock}>
        <button type="button" className={buttons.buttonOrange}>
          Your {isTeacher ? 'Anetapacks' : 'Scholars'}
        </button>
        <Modal
          isOpen={isOpenLibrary}
          trigger={
            <button
              disabled={!isActiveSubscription}
              type="button"
              className={buttons.buttonWhite}
            >
              Anetapack Library
            </button>
          }
          withoutBackground
          modalOpen={handleOpenLibrary}
          modalContent={
            <AnetaPackLibrary
              openNext={handleOpenContent}
              anetaPacks={anetaPacks || []}
              handleClose={handleOpenLibrary}
              handleChooseAnetapack={handleChooseAnetapack}
            />
          }
        />
      </div>
      <ScholarsList
        isActiveSubscription={isActiveSubscription}
        popupData={popupData}
      />
    </div>
  );
};

export default connect(mstp)(Scholars);
